const domain = window.location.origin;
const baseUrl = process.env.BUILD_ENV === 'dev' ? '/api' : `${domain}/common_gw/`;
const httpUrl = process.env.BUILD_ENV === 'dev' ? '/' : `${domain}/activityManagerH5/#/`;
// wxf38e89421d6d4ac2  wx6835f48e14528db8
const appId = process.env.BUILD_ENV === 'dev' || process.env.VUE_APP_BUILD_ENV === 'uat'
  ? 'wxf38e89421d6d4ac2' : 'wx37f0c9083ecc9197';
const authScope = process.env.BUILD_ENV === 'prod' ? 'snsapi_userinfo' : 'snsapi_base';

// 小程序版本release：正式版 trial：体验版 develop , 测试时使用体验版
const mini_env_version = process.env.BUILD_ENV === 'prod' ? 'release' : 'trial';
// 不需要登录的页面
const noLoginPages = ['video', 'styleTest', 'appletLogin']
// 跳转入网签约地址
const domainName = process.env.BUILD_ENV === 'prod' ? 'https://activity.quanyou.com.cn/unionPayAccessH5/' : 'https://tactivity.quanyou.com.cn/unionPayAccessH5/'

const QrCodeEnum = {
  // 加入活动
  join: 1,
  // 克隆活动
  clone: 2,
  // 报名核销
  verifySign: 3,
  // 抽奖核销
  lottery: 4,
  // 秒杀核销
  spike: 5,
  // 拼团核销
  group: 6,
  // 抽签核销
  drawLots: 7,
  // 红包挑战赛核销
  countMoney: 8,
  // 优惠券核销
  coupon: 9
}

// 活动标签
const activityTagEnum = {
  // 我创建
  myCreated: 1,
  // 经销商
  distributor: 2,
  // 活动老师
  teacher: 3,
  // 管理员
  manager: 4
};

// 活动状态
const activityStatusEnum = {
  // 草稿
  draft: 0,
  // 待开始
  toStarting: 1,
  // 进行中
  running: 2,
  // 已结束
  ended: 3,
};

export { baseUrl, httpUrl, appId, QrCodeEnum, activityTagEnum, activityStatusEnum, mini_env_version, authScope, noLoginPages,domainName}
